export const NIL_UUID = '00000000-0000-0000-0000-000000000000';

// Endpoints for which there should be successfull edit toast message displayed
export const EDIT_NOTIFICATION_ENDPOINTS = [['facility'], ['project'], ['project', 'user']].map(
  // Each value provided in array should be separated by guid regex, since endpoints look like controller/{id} or controller/{id}/inner/{id}
  e => e.reduce((acc, curr) => `${acc}\\/${curr}\\/\\b[0-9a-f]{8}\\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\\b[0-9a-f]{12}\\b`, '') + '$'
);
